import { DEFAULT_NAVIGATION_ICON_BY_CATALOG_KEY } from '@/constants/navigationIcons';

export function iconForNavItem(item) {
  if (item?.icon) return item.icon;
  return DEFAULT_NAVIGATION_ICON_BY_CATALOG_KEY[item?.catalogKey] || 'pi pi-circle';
}

export function labelForNavItem(item, locale = 'en') {
  if (!item?.label) return '';
  return locale === 'de' ? (item.label.de || item.label.en) : (item.label.en || item.label.de);
}

/**
 * Build top-level nav items and children map from flat customerNavigation array.
 */
export function buildNavigationTree(items) {
  if (!Array.isArray(items) || !items.length) {
    return { topLevel: [], childrenByParent: {} };
  }
  const sorted = [...items].sort((a, b) => a.sortOrder - b.sortOrder);
  const topLevel = sorted.filter((i) => !i.parentCatalogKey);
  const childrenByParent = {};
  sorted
    .filter((i) => i.parentCatalogKey)
    .forEach((child) => {
      const key = child.parentCatalogKey;
      if (!childrenByParent[key]) childrenByParent[key] = [];
      childrenByParent[key].push(child);
    });
  Object.keys(childrenByParent).forEach((k) => {
    childrenByParent[k].sort((a, b) => a.sortOrder - b.sortOrder);
  });
  return { topLevel, childrenByParent };
}

export function findNavItemByRoute(items, path) {
  if (!Array.isArray(items) || !path) return null;
  const normalized = String(path).split('?')[0];
  const links = items.filter((i) => i.itemKind === 'link' && typeof i.route === 'string');
  const matches = links.filter((i) => {
    const route = i.route;
    if (route === '/') return normalized === '/' || normalized === '';
    return normalized === route || normalized.startsWith(`${route}/`);
  });
  if (!matches.length) return null;
  matches.sort((a, b) => (b.route?.length || 0) - (a.route?.length || 0));
  return matches[0];
}
